import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { applicationNotesKey } from '@features/applicationNotes';
import { applicationNotesRoute } from '@features/applicationNotes/api/constants';
import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseUpdateApplicationNoteProps = {
  applicationId: number;
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateApplicationNote = ({
  applicationId,
  setErrorText = () => {},
}: UseUpdateApplicationNoteProps) => {
  const client = useQueryClient();

  const { mutate: updateNote, isLoading: isUpdateNoteLoading } = useMutation({
    mutationFn: (variables: {
      application_note_id: number;
      note: string;
      name: string;
    }) =>
      axiosInstance
        .put(applicationNotesRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
      }
      client.invalidateQueries([applicationNotesKey, applicationId]);
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    updateNote,
    isUpdateNoteLoading,
  };
};
